import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { getVisitorProfile, touchVisitorProfile, } from './visitor-storage.js';
const VisitorContext = createContext(null);
export function VisitorProvider({ children }) {
    const [visitor] = useState(() => touchVisitorProfile());
    const value = useMemo(() => ({
        visitor,
        kind: visitor.kind,
        isFirstVisit: visitor.kind === 'first',
        isReturningVisitor: visitor.kind === 'returning',
    }), [visitor]);
    return _jsx(VisitorContext.Provider, { value: value, children: children });
}
export function useVisitor() {
    const context = useContext(VisitorContext);
    if (!context) {
        const fallback = getVisitorProfile() ?? touchVisitorProfile();
        return {
            visitor: fallback,
            kind: fallback.kind,
            isFirstVisit: fallback.kind === 'first',
            isReturningVisitor: fallback.kind === 'returning',
        };
    }
    return context;
}
//# sourceMappingURL=VisitorProvider.js.map